export const propertyStructureEnums = {
  wooden: "木造",
  light_steel: "軽量鉄骨",
  heavy_steel: "重量鉄鋼",
  rc: "鉄筋コンクリート",
  src: "鉄筋鉄骨コンクリート"
};
